import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import 'moment/locale/zh-cn'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.prototype.emit = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')